export const confirmFn = (text: string, fn: () => void) => {
  if (confirm(text)) {
    fn();
  }
};



// WEBPACK FOOTER //
// ./src/actions/confirm.ts